module.exports = __webpack_public_path__ + "img/document-verified.fa0b4beb.svg";